import { useState } from "react";

import { View } from "react-native";
import { Button, HelperText, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import ReadyForPickupEstimateDrawer from "./ReadyForPickupEstimateDrawer";
import InfoText from "../../components/InfoText";
import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";
import { PickupCalculationMode } from "../../types";

export default function ReadyForPickupInfo() {
  const { readyForPickupEstimate, saveReadyForPickupEstimate } =
    useDeliveryFulfillments();
  const tailwind = useTailwind();

  const [modalVisible, setModalVisible] = useState(false);

  if (!readyForPickupEstimate) return null;

  const mode = readyForPickupEstimate.calculation_mode;
  const { icon, text } = getModeInfo(mode);

  function onEditReadyForPickup() {
    setModalVisible(true);
  }

  return (
    <>
      <View style={tailwind("gap-2")}>
        <InfoText title="Tiempo de preparación" />
        <HelperText type="info" padding="none">
          {text}
        </HelperText>
        <Text variant="bodyLarge" style={tailwind("font-semibold")}>
          {icon} {readyForPickupEstimate.time_text}
        </Text>

        {mode !== "average" && (
          <Button
            mode="outlined"
            style={tailwind("self-start")}
            onPress={onEditReadyForPickup}
          >
            Editar
          </Button>
        )}
      </View>
      <ReadyForPickupEstimateDrawer
        visible={modalVisible}
        onDismiss={() => setModalVisible(false)}
        currentEstimate={readyForPickupEstimate}
        onSave={async (estimatedHours) => {
          await saveReadyForPickupEstimate(estimatedHours);
          setModalVisible(false);
        }}
      />
    </>
  );
}

function getModeInfo(mode: PickupCalculationMode) {
  switch (mode) {
    case "average":
      return { icon: "✅", text: "Promedio de los últimos 30 días" };
    case "merchant":
      return { icon: "✏️", text: "Tu estimación" };
    case "default":
    default:
      return { icon: "⌛", text: "Usando valor por defacto" };
  }
}
